import { render } from "./PricingProfiles.vue?vue&type=template&id=214849fa&scoped=true"
import script from "./PricingProfiles.vue?vue&type=script&lang=js"
export * from "./PricingProfiles.vue?vue&type=script&lang=js"

import "./PricingProfiles.vue?vue&type=style&index=0&id=214849fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-214849fa"

export default script